<template>
  <v-container class="py-10">
    <v-row class="justify-center">
      <v-col v-for="(item, i) in items" :key="i" cols="12">
        <v-row class="d-flex align-center">
          <v-col cols="6" style="text-align: right;" class="py-1">{{
            item.title
          }}</v-col>
          <v-col class="text-white text-body-1 py-1" cols="6">
            <div
              v-html="item.text.replace(/<br>/g, '<br />')"
              style="text-align: left;"
            ></div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
  <!-- <campaign /> -->
</template>
<script>
  //  import campaign from "./TenpoTokuten.vue";
  export default {
    components: {
      //    campaign,
    },
    data: () => ({
      items: [
        {
          title: "商品名",
          text: "宵祓い探偵 ミアズマブレイカー",
        },
        {
          title: "ジャンル",
          text: "全方位除霊アクションシューティング",
        },
        {
          title: "プラットフォーム",
          text: "Nintendo Switch",
        },
        {
          title: "発売日",
          text: "2025.1.16",
        },
        {
          title: "プレイ人数",
          text: "1人",
        },
        {
          title: "CERO",
          text: "A",
        },
        {
          title: "メーカー希望小売価格",
          text: "4378円（税込）",
        },
      ],
    }),
  };
</script>
